import { otpApi } from "../../app/services/otpApiSlice";
import { ILoginResponse, IRequestLoginOtp, IVerifyLoginOtp } from "../../types/login";

const loginOtpApi = otpApi.injectEndpoints({
  endpoints: (builder) => ({
    requestLoginOtp: builder.mutation<any, IRequestLoginOtp>({
      query: (data) => ({
        url: `/auth/admin/otp-login`,
        method: "POST",
        body: data,
      }),
    }),
    verifyLoginOtp: builder.mutation<ILoginResponse, IVerifyLoginOtp>({
      query: (data) => ({
        url: `/auth/admin/verify-otp`,
        method: "POST",
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useRequestLoginOtpMutation, useVerifyLoginOtpMutation } = loginOtpApi;
